import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store/hooks'
import { setOpenBottomToast } from 'store/SharedData/sharedData.reducer'
import { selectBottomToast } from 'store/SharedData/sharedData.selectors'
import SydBottomMessage from 'components/Shared/SydBottomMessage/SydBottomMessage'
import { selectInvoicesManualXML } from 'store/Invoices/invoices.selectors'
import CFDIXmlStatusLabel from 'components/Invoices/NewCFDI/CFDIXmlStatusLabel/CFDIXmlStatusLabel'
import { setAllXmlsAmount, setDuplicatedXMLs, setErrorXMLs, setIsMoreDetailsModalOpen, setSuccesXmlsAmount } from 'store/Invoices/invoices.reducer'
import CFDIMoreDetailsLabel from 'components/Invoices/NewCFDI/CFDIMoreDetailsLabel/CFDIMoreDetailsLabel'

const BottomMessagesHub = () => {
  const { open, message } = useSelector(selectBottomToast);
  const { duplicatedXMLs, errorXMLs, successXmlsAmount, allXmlsAmount } = useSelector(selectInvoicesManualXML);

  const dispatch = useAppDispatch()

  const handleCloseMessage = useCallback(() => {
    dispatch(setOpenBottomToast(false))
    dispatch(setDuplicatedXMLs([]))
    dispatch(setErrorXMLs([]))
    dispatch(setSuccesXmlsAmount(0))
    dispatch(setAllXmlsAmount(0))
  }, [dispatch])

  const handleSeeMoreDetails = useCallback(() => {
    dispatch(setIsMoreDetailsModalOpen(true))
  }, [dispatch])

  return (
    <>
      {(open === true) && (
        <SydBottomMessage 
          title={message} 
          handleClose={handleCloseMessage} 
        >
          {allXmlsAmount > 0 && (
            <CFDIXmlStatusLabel 
            description={`${successXmlsAmount} de ${allXmlsAmount} CARGADOS CON ÉXITO`} 
            status="ok"
          />
          )}          

          {duplicatedXMLs.length > 0 && (
            <CFDIXmlStatusLabel 
              description={`${duplicatedXMLs.length} de ${allXmlsAmount} DUPLICADOS `} 
              status="duplicated"
            />
          )}

          {errorXMLs.length > 0 && (
            <CFDIXmlStatusLabel 
              description={`${errorXMLs.length} de ${allXmlsAmount} CON EROR AL CARGAR `} 
              status="error"
            />
          )}

          {(allXmlsAmount > 0) && (
            <CFDIMoreDetailsLabel 
              onClick={handleSeeMoreDetails}
            />
          )}
        </SydBottomMessage>
      )}
    </>
  )
}

export default BottomMessagesHub
